if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cartNotification = document.querySelector("cart-notification");
        this.cartDrawer = document.querySelector("cart-drawer summary");

        this.addEventListener("change", this.rcChange);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const submitButton = this.querySelector('[type="submit"]');
        if (submitButton.classList.contains("loading")) return;

        this.handleErrorMessage();
        //this.cartNotification.setActiveElement(document.activeElement);

        submitButton.setAttribute("aria-disabled", true);
        submitButton.classList.add("loading");
        const loadingSpinner = this.querySelector(".loading-overlay__spinner");
        if (loadingSpinner) {
          loadingSpinner.classList.remove("hidden");
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        //formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
        formData.append("sections_url", window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);
              return;
            }
            this.handleKlaviyoTracking();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButton.classList.remove("loading");
            submitButton.removeAttribute("aria-disabled");
            const loadingSpinner = this.querySelector(".loading-overlay__spinner");
            if (loadingSpinner) {
              loadingSpinner.classList.add("hidden");
            }
            if (document.querySelector(".mfp-close")) {
              document.querySelector(".mfp-close").click();
            }
            setTimeout(() => {
              this.cartDrawer.click();
            }, 300);
          });
      }

      handleKlaviyoTracking() {
        var _learnq = window._learnq || [];
        //creat 'item' object
        let dataRef = this.form.parentElement.dataset;
        const item = {
          $is_session_activity: true,
          $use_ip: true,
          Brand: "Plant Therapy",
          CompareAtPrice: dataRef.compareAtPrice,
          Name: dataRef.name,
          Price: dataRef.price,
          ImageURL: dataRef.image,
          Categories: dataRef.categories,
          URL: dataRef.url,
        };
        _learnq.push(["track", "Added to Cart", item]);
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        
        if (!this.errorMessageWrapper) {
          console.warn('Error message wrapper not found in product form');
          return;
        }
        
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      rcChange(evt) {
        let element = evt.target;
        if (element.classList.contains("rc-radio__input")) {
          const points = Math.floor(
            Number(
              evt.target.nextSibling
                .querySelector(".rc_widget__price")
                .innerHTML.replace(/[^0-9.-]+/g, "")
            )
          );
          document.querySelector(".pt-points").innerHTML = points;
        }
      }
    }
  );
}
